export default __webpack_public_path__ + "static/media/Harness of the Berserker's Fury.eb92b663.jpg";